import styles from "./Popup.module.css";
import { ReactComponent as CancelBoxIcon } from "../../../assets/svg/cancel-box.svg";

const Popup = ({ show, title, children, onClose }) => {
    return (
        <>
            <div className={`${styles.PopupBack} ${show ? styles.show: ""}`} onClick={onClose} />
            <div className={`${styles.Popup} ${show ? styles.show : ""}`}>
                <div className={styles.Content}>
                    <div className={styles.Header}>
                        <h1>{title}</h1>
                        <CancelBoxIcon style={{ width: 20, height: 20 }} onClick={onClose} />
                    </div>
                    {children}
                </div>
            </div>
        </>
    )
}

export default Popup